// ─── BACKEND CONFIG ──────────────────────────────────────────────────
import { Capacitor } from '@capacitor/core';

// ponytail: native WebView has no same-origin /api — set REACT_APP_APP_PUBLIC_URL at mobile build time
const DEFAULT_NATIVE_API = 'https://foundersbridge.app/api';

function resolveApiBase() {
  const explicit = (process.env.REACT_APP_API_BASE || '').trim().replace(/\/$/, '');
  if (explicit) return explicit.endsWith('/api') ? explicit : `${explicit}/api`;

  if (typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform()) {
    const origin = (process.env.REACT_APP_APP_PUBLIC_URL || '').trim().replace(/\/$/, '');
    return origin ? `${origin}/api` : DEFAULT_NATIVE_API;
  }
  return '/api';
}

function resolveAppPublicUrl() {
  const explicit = (process.env.REACT_APP_APP_PUBLIC_URL || '').trim().replace(/\/$/, '');
  if (explicit) return explicit;
  if (typeof window !== 'undefined' && window.location?.origin) {
    const origin = window.location.origin;
    if (!/localhost|127\.0\.0\.1/i.test(origin)) return origin;
  }
  return 'https://foundersbridge.app';
}

export const APP_PUBLIC_URL = resolveAppPublicUrl();
export const API_BASE = resolveApiBase();
export const STORAGE_API = process.env.REACT_APP_STORAGE_API || `${API_BASE}/storage`;

export const POLL_INTERVAL = 90000; // legacy alias
export const CLIENT_POLL_INTERVAL = 45000; // SSE fallback poll when stream disconnected
export const STAFF_POLL_INTERVAL = 90000;

const getPlatformClass = () => {
  if (typeof Capacitor !== "undefined" && Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform() === "ios" ? "platform-ios" : "platform-android";
  }
  if (typeof navigator === "undefined") return "platform-desktop";
  const ua = navigator.userAgent || "";
  const isTouchMac = (navigator.platform || "") === "MacIntel" && navigator.maxTouchPoints > 1;
  if (/iPad|iPhone|iPod/.test(ua) || isTouchMac) return "platform-ios";
  if (/Android/i.test(ua)) return "platform-android";
  return "platform-desktop";
};
export const PLATFORM_CLASS = getPlatformClass();
